import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import ExportCsvButton from "@/components/ExportCsvButton";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/customers").then(({ data }) => setList(data || []));
  }, []);

  const filtered = list.filter((u) =>
    !q || u.full_name.toLowerCase().includes(q.toLowerCase()) || u.email.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <DashboardLayout role="admin">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-semibold text-ink sm:text-3xl">Customers</h1>
          <p className="mt-1 text-sm text-ink-soft">Your CRM — every client, every application, every loan.</p>
        </div>
        <div className="flex items-center gap-2">
          <ExportCsvButton endpoint="customers.csv" filename="jrc_customers.csv" testId="customers-export-csv" />
          <Input placeholder="Search name or email…" value={q} onChange={(e) => setQ(e.target.value)} className="w-72" data-testid="customers-search" />
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-[#E5E2DE] bg-white">
        <div className="hidden grid-cols-12 gap-4 border-b border-[#E5E2DE] bg-[#F9F6F0] px-5 py-3 text-xs font-semibold uppercase tracking-wider text-ink-muted md:grid">
          <div className="col-span-4">Name / Email</div>
          <div className="col-span-3">Phone</div>
          <div className="col-span-1 text-right">Apps</div>
          <div className="col-span-1 text-right">Loans</div>
          <div className="col-span-1 text-right">Active</div>
          <div className="col-span-2 text-right">Joined</div>
        </div>
        {filtered.length === 0 ? (
          <div className="px-5 py-10 text-center text-sm text-ink-soft">No customers found.</div>
        ) : filtered.map((u) => (
          <Link
            key={u.id}
            to={`/admin/customers/${u.id}`}
            data-testid={`customer-row-${u.id}`}
            className="grid grid-cols-1 gap-2 border-b border-[#E5E2DE] px-5 py-4 transition-colors last:border-b-0 hover:bg-[#F9F6F0] md:grid-cols-12 md:gap-4"
          >
            <div className="md:col-span-4">
              <div className="font-heading text-sm font-semibold text-ink">{u.full_name}</div>
              <div className="text-xs text-ink-muted">{u.email}</div>
            </div>
            <div className="text-sm text-ink-soft md:col-span-3">{u.phone || "—"}</div>
            <div className="text-sm md:col-span-1 md:text-right">{u.applications_count}</div>
            <div className="text-sm md:col-span-1 md:text-right">{u.loans_count}</div>
            <div className="text-sm md:col-span-1 md:text-right">{u.active_loans}</div>
            <div className="text-xs text-ink-muted md:col-span-2 md:text-right">{new Date(u.created_at).toLocaleDateString()}</div>
          </Link>
        ))}
      </div>
    </DashboardLayout>
  );
}
